module.exports = __webpack_public_path__ + "static/media/images2.55891d36.png";